import i18n from '@if/core/i18n'

/**
 * @deprecated
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const translate = (key: any, params: Record<string, string | number> = {}): string => {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
  return i18n.t(key, { replace: params }) as string
}

export default translate
